module.exports = __webpack_public_path__ + "img/none_background.c4feef2f.png";